(function () {
  if (window.CartShippingProgressInitialized) return;
  window.CartShippingProgressInitialized = true;

  function formatMoneyText(cents, format) {
    var formatted;

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      formatted = window.Shopify.formatMoney(cents, format);
    } else {
      formatted = ((Number(cents) || 0) / 100).toFixed(2);
    }

    var temporary = document.createElement("div");
    temporary.innerHTML = formatted;
    return temporary.textContent || temporary.innerText || "";
  }

  function updateProgress(root, cart) {
    if (!root || !cart) return;

    var threshold = Number(root.getAttribute("data-threshold-cents")) || 0;
    var total = Number(cart.total_price) || 0;
    if (threshold <= 0) return;

    var remaining = Math.max(threshold - total, 0);
    var progress = Math.min(Math.max((total / threshold) * 100, 0), 100);
    var reached = total >= threshold;
    var message = root.querySelector("[data-shipping-progress-message]");
    var track = root.querySelector("[data-shipping-progress-track]");
    var bar = root.querySelector("[data-shipping-progress-bar]");
    var template = reached
      ? root.getAttribute("data-success-text") || ""
      : root.getAttribute("data-progress-text") || "";

    if (message) {
      var amountText = formatMoneyText(
        remaining,
        root.getAttribute("data-money-format") || "${{amount}}"
      );

      message.textContent = "";
      template.split("[amount]").forEach(function (part, index, parts) {
        message.appendChild(document.createTextNode(part));
        if (!reached && index < parts.length - 1) {
          var amount = document.createElement("span");
          amount.className = "cart-shipping-progress__amount";
          amount.textContent = amountText;
          message.appendChild(amount);
        }
      });
    }

    if (bar) bar.style.width = progress + "%";
    if (track) track.setAttribute("aria-valuenow", String(Math.round(progress)));
    root.setAttribute("data-goal-reached", String(reached));
  }

  function updateAll(cart) {
    document.querySelectorAll("[data-cart-shipping-progress]").forEach(function (root) {
      updateProgress(root, cart);
    });
  }

  window.addEventListener("theme:cart-updated", function (event) {
    updateAll(event.detail);
  });
})();
